export const tickerNews = [
  { time: "刚刚", text: "热门综艺《追光企划》收官舞台词条冲上热搜，阅读量一小时破三亿" },
  { time: "12分钟前", text: "全国多地迎来首个高温日，气象台发布今年首个高温橙色预警" },
  { time: "28分钟前", text: "某国产新能源车企发布新一代智驾系统，股价盘中拉升" },
  { time: "40分钟前", text: "顶流歌手新专辑预约量破纪录，评论区被粉丝刷屏" },
  { time: "55分钟前", text: "网红城市夜游经济持续升温，景区上线深夜快线" },
  { time: "1小时前", text: "年度暑期档电影定档潮来袭，多部大制作同台对垒" },
];

export const hotRank = [
  { rank: 1, tag: "热", category: "综艺", title: "《追光企划》决赛夜名场面盘点，谁才是你的意难平？", heat: "4823.6万", delta: "up", color: "primary" },
  { rank: 2, tag: "沸", category: "社会", title: "多地高温破纪录，防暑降温小贴士请收好", heat: "3912.4万", delta: "up", color: "accent" },
  { rank: 3, tag: "热", category: "汽车", title: "新一代智能驾驶实测：城市领航到底有多能打？", heat: "2847.9万", delta: "up", color: "secondary" },
  { rank: 4, tag: "新", category: "音乐", title: "顶流歌手新专首日预约破百万，实体版秒空", heat: "2210.5万", delta: "new", color: "primary" },
  { rank: 5, tag: "热", category: "影视", title: "暑期档定档片单出炉，哪一部最值得蹲首映？", heat: "1938.2万", delta: "down", color: "accent" },
  { rank: 6, tag: "热", category: "文旅", title: "小城「反向旅游」走红，避开人海的松弛周末指南", heat: "1567.0万", delta: "down", color: "secondary" },
  { rank: 7, tag: "新", category: "体育", title: "亚运会火炬手名单官宣，全民健身热持续升温", heat: "1204.6万", delta: "new", color: "primary" },
];

export const liveItems = [
  { time: "20:46", badge: "直击", title: "决赛夜现场：观众席灯海如潮，选手返场致谢", category: "综艺", reads: "218万围观", image: "https://readdy.ai/api/search-image?query=Concert%20arena%20stage%20filled%20with%20golden%20audience%20light%20sticks%20and%20colorful%20spotlights%2C%20warm%20editorial%20night%20scene%2C%20cinematic%20crowd%20silhouettes%2C%20energetic%20festive%20atmosphere%2C%20soft%20bokeh%2C%20high%20detail%2C%20harmonious%20warm%20tones&width=800&height=520&seq=live-01&orientation=landscape" },
  { time: "19:32", badge: "现场", title: "新车发布会抢先看：三联屏座舱与城市领航首秀", category: "汽车", reads: "176万围观", image: "https://readdy.ai/api/search-image?query=Modern%20electric%20vehicle%20launch%20event%20on%20dark%20stage%20with%20warm%20amber%20rim%20lighting%2C%20gleaming%20concept%20car%20showcase%2C%20premium%20technology%20conference%20ambience%2C%20clean%20minimalist%20composition%2C%20cinematic%20depth&width=800&height=520&seq=live-02&orientation=landscape" },
  { time: "18:05", badge: "围观", title: "街头随机采访：年轻人眼中的「松弛感」是什么？", category: "生活", reads: "143万围观", image: "https://readdy.ai/api/search-image?query=Candid%20street%20interviews%20in%20a%20sunny%20pedestrian%20street%20with%20young%20people%20laughing%2C%20warm%20natural%20lighting%2C%20documentary%20reportage%20style%2C%20authentic%20city%20life%2C%20soft%20warm%20tones%2C%20editorial%20photography&width=800&height=520&seq=live-03&orientation=landscape" },
  { time: "16:47", badge: "直击", title: "博物馆奇妙夜启幕，夜游看展成新潮流", category: "文旅", reads: "98万围观", image: "https://readdy.ai/api/search-image?query=Grand%20museum%20atrium%20at%20dusk%20with%20warm%20interior%20lights%2C%20elegant%20exhibition%20halls%2C%20visitors%20admiring%20artwork%2C%20golden%20hour%20glow%2C%20cultural%20heritage%20ambience%2C%20cinematic%20warm%20palette&width=800&height=520&seq=live-04&orientation=landscape" },
  { time: "15:20", badge: "现场", title: "顶流歌手录音室花絮流出，新专辑风格大猜想", category: "音乐", reads: "132万围观", image: "https://readdy.ai/api/search-image?query=Professional%20music%20recording%20studio%20with%20warm%20vintage%20tone%2C%20microphone%20and%20mixer%20in%20soft%20golden%20light%2C%20artistic%20atmosphere%2C%20creative%20workflow%20detail%2C%20cinematic%20warm%20ambience&width=800&height=520&seq=live-05&orientation=landscape" },
  { time: "13:58", badge: "围观", title: "社区咖啡馆走红：人均20元喝出松弛下午茶", category: "美食", reads: "87万围观", image: "https://readdy.ai/api/search-image?query=Cozy%20neighborhood%20coffee%20shop%20counter%20with%20warm%20wood%20tones%2C%20barista%20serving%20a%20latte%2C%20plants%20and%20soft%20window%20light%2C%20relaxed%20homely%20vibe%2C%20food%20photography%2C%20warm%20harmonious%20palette&width=800&height=520&seq=live-06&orientation=landscape" },
];

export const columns = [
  {
    id: "star",
    name: "明星八卦",
    icon: "ri-star-smile-line",
    intro: "圈内新鲜事一网打尽",
    bg: "bg-primary-100/70",
    fg: "text-primary-700",
    posts: [
      { title: "《追光企划》决赛意难平：粉丝为何集体「破防」", reads: "6.2万" },
      { title: "时隔三年，他带着新作杀回综艺现场", reads: "5.1万" },
      { title: "荧幕CP售后营业，甜度拉满引发刷屏", reads: "4.3万" },
    ],
  },
  {
    id: "society",
    name: "社会百态",
    icon: "ri-earth-line",
    intro: "民生热点理性围观",
    bg: "bg-accent-100/70",
    fg: "text-accent-900",
    posts: [
      { title: "高温下的城市：外卖小哥的一天怎么过？", reads: "8.8万" },
      { title: "「夜经济」点亮小城，烟火气回归街头", reads: "6.7万" },
      { title: "反向旅游风潮下，小城如何接住流量？", reads: "5.6万" },
    ],
  },
  {
    id: "tech",
    name: "科技风向",
    icon: "ri-cpu-line",
    intro: "前沿资讯快速速看",
    bg: "bg-secondary-100/70",
    fg: "text-secondary-900",
    posts: [
      { title: "智驾新战局：城市领航开启「巷战」", reads: "7.9万" },
      { title: "国产手机影像再进化，计算摄影成主战场", reads: "5.4万" },
      { title: "大模型应用落地，办公提效真实体验报告", reads: "4.8万" },
    ],
  },
  {
    id: "ent",
    name: "影视娱乐",
    icon: "ri-film-line",
    intro: "片单与热映速递",
    bg: "bg-background-200/80",
    fg: "text-foreground-800",
    posts: [
      { title: "暑期档大幕拉开，多部新片抢占首映档", reads: "9.1万" },
      { title: "《重启》剧版口碑逆袭，网友直呼上头", reads: "6.9万" },
      { title: "年度口碑之作重映，经典为何历久弥新", reads: "4.6万" },
    ],
  },
];

export const digestPosts = [
  {
    category: "汽车",
    time: "今天 08:30",
    title: "不止是炫技：智能驾驶进入「好用」元年",
    excerpt: "当城市领航从发布会PPT走进真实路口，普通车主终于开始关心一个问题：它到底安不安全、好不好用？我们从实测数据与车主反馈出发，聊聊智驾的拐点。",
    image: "https://readdy.ai/api/search-image?query=Close%20up%20of%20modern%20electric%20car%20dashboard%20with%20touchscreen%20navigation%20showing%20city%20map%2C%20warm%20dashboard%20lighting%2C%20premium%20interior%2C%20futuristic%20yet%20clean%2C%20cinematic%20automotive%20photography&width=560&height=400&seq=digest-01&orientation=landscape",
  },
  {
    category: "社会",
    time: "今天 07:12",
    title: "夜市回归：一地摊经济背后的城市温度",
    excerpt: "从街角小吃到深夜书摊，夜市的重新点亮不只是生意，更是城市对生活烟火气的接纳。跟随我们的镜头，走进三座小城的深夜街头。",
    image: "https://readdy.ai/api/search-image?query=Vibrant%20night%20market%20street%20with%20warm%20string%20lights%20and%20steaming%20food%20stalls%2C%20crowds%20enjoying%20street%20food%2C%20cozy%20evening%20atmosphere%2C%20golden%20warm%20tones%2C%20editorial%20documentary%20photography&width=560&height=400&seq=digest-02&orientation=landscape",
  },
  {
    category: "文旅",
    time: "昨天 22:40",
    title: "「反向旅游」报告：小城如何在流量中自洽",
    excerpt: "当大景区人山人海，越来越多人选择钻进小城慢逛。小城靠什么接住这波流量，又该如何避免「火一阵就凉」？几位主理人分享真实想法。",
    image: "https://readdy.ai/api/search-image?query=Peaceful%20ancient%20town%20canal%20with%20traditional%20architecture%20and%20reflections%20at%20golden%20hour%2C%20few%20strolling%20visitors%2C%20tranquil%20warm%20atmosphere%2C%20travel%20photography%2C%20cinematic%20warm%20palette&width=560&height=400&seq=digest-03&orientation=landscape",
  },
  {
    category: "生活",
    time: "昨天 20:15",
    title: "年轻人的松弛哲学：把周末还给兴趣",
    excerpt: "露营、徒步、手作、citywalk……年轻人正在用五花八门的方式重新定义休息。我们走访了几个兴趣社群，听他们聊聊何为真正的「充电」。",
    image: "https://readdy.ai/api/search-image?query=Young%20friends%20having%20a%20picnic%20and%20camping%20in%20a%20sunny%20park%20at%20dusk%2C%20warm%20campfire%20light%2C%20relaxed%20outdoor%20lifestyle%2C%20golden%20hour%2C%20editorial%20lifestyle%20photography&width=560&height=400&seq=digest-04&orientation=landscape",
  },
];

export const faqItems = [
  { q: "17吃瓜的内容多久更新一次？", a: "我们会对全网热议话题进行实时聚合与人工梳理，热点高峰时段通常每几分钟就有更新。重要事件会在「现场直击」板块以时间线形式跟进，确保你不错过关键节点。" },
  { q: "如何快速找到我今天想围观的热点？", a: "你可以在首屏「今日热榜」查看按热度排序的榜单，也可以通过顶部导航或「主题分类」板块，按明星八卦、社会百态、科技风向、影视娱乐等栏目定向浏览感兴趣的领域。" },
  { q: "内容来源可靠吗？", a: "我们坚持「先核实、后发布」的原则，对转载与聚合内容进行交叉核对，并在速报中区分「直击现场」与「观点解读」。涉及存疑的信息会明确标注，欢迎用户留言提供线索与补充。" },
  { q: "订阅热点速报能收到什么？", a: "订阅后将定期收到精选的热点速报摘要，涵盖当日最值得围观的事件、榜单变化与深度解读，帮助你在碎片时间里高效掌握最新动态，不迷路。" },
  { q: "我发现了有趣话题想投稿或爆料怎么办？", a: "非常欢迎！你可以通过页面底部的联系方式留言，或在本页评论区提交话题线索。一经采用，我们会以适当方式标注来源，并感谢你的贡献。" },
];